"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animation = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _framerMotion = require("framer-motion");

var Container = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

exports.Container = Container;
Container.Overlay = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  overflow: hidden;\n"])));
var Animation = (0, _stylitas.styled)(_framerMotion.motion.div)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));
exports.Animation = Animation;